import { render, staticRenderFns } from "./PqtList.vue?vue&type=template&id=6d193d9b"
import script from "./PqtList.vue?vue&type=script&lang=ts"
export * from "./PqtList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports